module.exports = __webpack_public_path__ + "img/kommune-1714.a614769c.svg";